/**
 * Testimonials Component - Sleek Theme OS 2.0
 */
if (!customElements.get('testimonials-component')) {
  class TestimonialsComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.testimonials-slider');
      this.track = this.querySelector('.testimonials-track');
      this.slides = Array.from(this.querySelectorAll('.testimonials-slide'));
      this.prevBtn = this.querySelector('[data-action="prev"]');
      this.nextBtn = this.querySelector('[data-action="next"]');
      this.currentIndex = 0;
      this.itemsPerView = 4;
    }

    connectedCallback() {
      this.calculateItemsPerView();
      this.bindEvents();
      this.updateControls();
      window.addEventListener('resize', this.debounce(() => {
        this.calculateItemsPerView();
        this.goToSlide(this.currentIndex);
      }, 150));
    }

    calculateItemsPerView() {
      const width = window.innerWidth;
      if (width >= 1024) {
        this.itemsPerView = 4;
      } else if (width >= 640) {
        this.itemsPerView = 2;
      } else {
        this.itemsPerView = 1;
      }
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }

      // Keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prev();
        if (e.key === 'ArrowRight') this.next();
      });
    }

    maxIndex() {
      return Math.max(0, this.slides.length - this.itemsPerView);
    }

    prev() {
      if (this.currentIndex > 0) {
        this.goToSlide(this.currentIndex - 1);
      }
    }

    next() {
      if (this.currentIndex < this.maxIndex()) {
        this.goToSlide(this.currentIndex + 1);
      }
    }

    goToSlide(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.maxIndex()));
      if (this.track && this.slides[0]) {
        const slideWidth = this.slides[0].getBoundingClientRect().width;
        const gap = 24; // 1.5rem
        const offset = this.currentIndex * (slideWidth + gap);
        this.track.style.transform = `translateX(-${offset}px)`;
      }
      this.updateControls();
    }

    updateControls() {
      if (this.prevBtn) {
        this.prevBtn.disabled = this.currentIndex === 0;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = this.currentIndex >= this.maxIndex();
      }
    }

    debounce(fn, delay) {
      let timer;
      return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    }
  }

  customElements.define('testimonials-component', TestimonialsComponent);
}
